import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import history from 'app/routes/history';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  organisationFeeSchema,
  organisationFeeListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/organisationFees/actions';
import { OrganisationFeesActionTypes as types } from 'app/ducks/organisationFees/types';

function* createOrganisationFeeSaga(action): any {
  yield put(sagaActions.createOrganisationFeePending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationFees.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, organisationFeeSchema);
    yield put(sagaActions.createOrganisationFeeSuccess(normalizedResponse));
    setTimeout(() => {
      history.push(`/competitions/${action.payload.competition.id}`);
    }, 1000);
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createOrganisationFeeFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateOrganisationFeeSaga(action): any {
  yield put(sagaActions.updateOrganisationFeePending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationFees.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, organisationFeeSchema);

    yield put(sagaActions.updateOrganisationFeeSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateOrganisationFeeFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getOrganisationFeeSaga(action): any {
  yield put(sagaActions.getOrganisationFeePending());

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationFees.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, organisationFeeSchema);
    yield put(sagaActions.getOrganisationFeeSuccess(normalizedResponse));
    return normalizedResponse.entities.organisationFees[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getOrganisationFeeFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllOrganisationFeesSaga(action): any {
  yield put(
    sagaActions.getAllOrganisationFeesPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());
  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.organisationFees.pagination),
    )
    : action.payload.pagination;
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationFees.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(
      response,
      organisationFeeListSchema,
    );

    yield put(
      sagaActions.getAllOrganisationFeesSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllOrganisationFeesFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createOrganisationFeeSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_ORGANISATION_FEE_REQUESTED,
    createOrganisationFeeSaga,
  );
}

function* updateOrganisationFeeSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_ORGANISATION_FEE_REQUESTED,
    updateOrganisationFeeSaga,
  );
}

function* getOrganisationFeeSagaWatcher(): any {
  yield takeLatest(
    types.GET_ORGANISATION_FEE_REQUESTED,
    getOrganisationFeeSaga,
  );
}

function* getAllOrganisationFeesSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_ORGANISATION_FEES_REQUESTED,
    getAllOrganisationFeesSaga,
  );
}

export default function* root(): any {
  yield all([
    createOrganisationFeeSagaWatcher(),
    updateOrganisationFeeSagaWatcher(),
    getOrganisationFeeSagaWatcher(),
    getAllOrganisationFeesSagaWatcher(),
  ]);
}
